import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Finder from './Finder';
import HomePage from './HomePage';
import CategoryPage from './CategoryPage';
import WallpaperBackground from './WallpaperBackground';
import { QueryData } from '../types/types';
import { GET_DEEP_CATEGORY_BY_SLUG } from '../graphql/categoriesQuery';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

const PageTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-PSG9DGG9VY', {
        page_path: location.pathname + location.search,
        page_title: document.title, // Use actual page title from SEO system
      });
    }
  }, [location]);

  return null;
};

const Launcher: React.FC = () => {
  // Prefetch music category data for performance
  const { data } = useQuery<QueryData, { slug: string }>(GET_DEEP_CATEGORY_BY_SLUG, {
    variables: { slug: "music" },
    fetchPolicy: "cache-first",
  });

  return (
    <div className="flex" id="launcher">
      <WallpaperBackground />
      <Router>
        <PageTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/*" element={<Finder />}>
            <Route path="contact" element={<div>Contact Page</div>} />
            <Route path="*" element={<CategoryPage />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
};

export default Launcher;